import { ActiveFilters, SearchFilter, SearchKeyword } from 'store/search/types';

export default function getKeywordsFromFilters(filters: SearchFilter[], selection: ActiveFilters) {
  const keywords: SearchKeyword[] = [];
  filters.forEach((filter) => {
    filter.facets.forEach((facet) => {
      if (selection[filter.id]) {
        const isSelected = selection[filter.id].indexOf(facet.value) > -1;
        if (isSelected) {
          keywords.push({
            keyword: facet.name,
            value: facet.value,
            filterId: filter.id,
          });
        }
      }
    });
  });
  return keywords;
}
